<template>
    <div class="orderDialog">
        <div class="titleBox">
            <span>下单确认</span>
            <van-icon name="cross" size="20" class="closeIcon" @click="close"/>
        </div>
        <div class="formData">
            <template v-if="is_empl_order">
                <div class="formItem" @click="openCheckUser">
                    <img src="@/assets/rescueImgs/valid1.png" alt="" class="formIcon">
                    <div class="inputBox">{{ form.userId ? `${form.name}` : '请选择员工' }}</div>
                    <van-icon name="arrow" size="14" color="#B1B1B1"/>
                </div>
                <div class="formItem" @click="openCheckUser" v-if="form.userId">
                    <img src="@/assets/rescueImgs/valid2.png" alt="" class="formIcon">
                    <div class="inputBox">{{ form.userId ? form.mobile : '请选择员工' }}</div>
                    <van-icon name="arrow" size="14" color="#B1B1B1"/>
                </div>
                <div class="formItem">
                    <img src="@/assets/rescueImgs/valid3.png" alt="" class="formIcon">
                    <van-field class="inputBox" v-model="form.code" type="number" placeholder="请输入验证码"></van-field>
                    <span class="codeText" @click="getCode()">{{ codeText }}</span>
                </div>
            </template>
            <div class="formItem" v-if="is_pass_order">
                <img src="@/assets/rescueImgs/valid4.png" alt="" class="formIcon">
                <van-field class="inputBox" v-model="form.order_pwd" placeholder="请输入下单密码"></van-field>
            </div>
        </div>
        <div class="footerBox" @click="submit">
            确认下单
        </div>

        <!-- 选择员工 -->
        <van-popup v-model="checkUserVsi" position="bottom" get-container="#app" class="checkUserCom">
            <div class="titleBox">
                <span>选择下单人员</span>
                <van-icon name="cross" size="20" class="closeIcon" @click="checkUserVsi = false"/>
            </div>
            <div class="userList">
                <div :class="['userLi', { 'activeUser': item.id == checkUserInfo.id }]" v-for="(item, index) in employeeData" :key="index" @click="checkUser(item)">
                    <div class="nameBox">
                        <span>{{ item.name }}</span>
                        <span class="job_number">{{ item.job_number }}</span>
                    </div>
                    <div class="mobile">{{ item.mobile }}</div>
                    <img :src="item.id == checkUserInfo.id ? radio_y : radio_n" alt="" class="icon">
                </div>
            </div>
            <div class="affirmUser" @click="affirmUser">
                确 定
            </div>
        </van-popup>
    </div>
</template>

<script>
import { getCode } from '@/apis/join'
export default {
    props: {
        // 是否密码下单
        is_pass_order: {
            type: Boolean,
            default: true
        },
        // 是否员工下单
        is_empl_order: {
            type: Boolean,
            default: false
        },
        // 可用的员工列表
        employeeData: {
            type: Array,
            default: []
        },
    },
    data(){
        return {
            form: {
                userId: '',
                name: '',
                mobile: '',
                code: '',       //员工手机验证码
                order_pwd: '',      //下单密码
            },
            codeText: '获取验证码',
            codeTime: 60,
            timer: null,
            checkUserVsi: false,
            checkUserInfo: {
                id: '',
                name: '',
                mobile: '',
            },
            radio_n: require('@/assets/join/radio_n.png'),
            radio_y: require('@/assets/join/radio_y.png'),
        }
    },
    methods: {
        close(){
            this.$emit('close')
        },
        // 选择员工
        openCheckUser(){
            if(this.form.userId){
                this.checkUserInfo = {
                    id: this.form.userId,
                    name: this.form.name,
                    mobile: this.form.mobile,
                }
            }else{
                this.checkUserInfo = {
                    id: '',
                    name: '',
                    mobile: '',
                }
            }
            this.checkUserVsi = true
        },
        checkUser(e){
            this.checkUserInfo = e
        },
        affirmUser(){
            if(!this.checkUserInfo.id){
                this.$toast('请选择下单人员！')
                return
            }
            this.form.userId = this.checkUserInfo.id
            this.form.name = this.checkUserInfo.name
            this.form.mobile = this.checkUserInfo.mobile
            this.checkUserVsi = false
        },
        // 获取短信验证码
        getCode(){
            if(this.codeTime != 60) return
            if(!this.form.userId){
                this.$toast('请选择下单人员！')
                return
            }
            if(this.form.mobile.length != 11){
                this.$notify({
                    type: 'danger',
                    message: '手机号错误！'
                })
                return
            }else{
                let params = {
                    mobile: this.form.mobile
                }
                getCode(params).then((res)=>{
                    this.$toast(res.data.info);
                    if(res.data.code == 1){
                        --this.codeTime;
                        this.codeText = `${this.codeTime}秒重新获取`
                        this.timefunc()
                    }
                })
            }
        },
        timefunc(){
            this.timer = setInterval((e)=>{
                if(this.codeTime <= 1){
                    clearInterval(this.timer)
                    this.timer = null
                    this.codeText = '获取验证码'
                    this.codeTime = 60
                }else{
                    --this.codeTime;
                    this.codeText = `${this.codeTime}秒重新获取`
                }
            }, 1000)
        },
        submit(){
            if(this.is_empl_order){
                // 员工下单
                if(!this.form.userId){
                    this.$toast('请选择下单人员！')
                    return
                }
                if(!this.form.code){
                    this.$toast('请输入手机验证码！')
                    return
                }
            }
            if(this.is_pass_order){
                // 密码下单
                if(!this.form.order_pwd){
                    this.$toast('请输入下单密码！')
                    return
                }
            }
            console.log(this.form)
            let data = {
                order_pwd: this.form.order_pwd,      //下单密码
                employee_mobile: this.form.mobile,        //员工手机号
                code: this.form.code       //员工手机验证码
            }
            this.$emit('affirmCreate', data)
        }
    }
}
</script>

<style lang="scss">
    .orderDialog{
        .van-cell{
            padding: 0;
            box-sizing: border-box;
        }
        .van-field__control:disabled {
            color: #323233;
            -webkit-text-fill-color: #323233;
        }
    }
</style>
<style lang="scss" scoped>
    .orderDialog, .checkUserCom{
        padding: 0 16px 20px;
        box-sizing: border-box;
        .closeIcon{
            position: absolute;
            top: 10px;
            right: 10px;
        }
        .titleBox{
            height: 44px;
            text-align: center;
            line-height: 44px;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 5px;
        }
        .formData{
            display: flex;
            flex-direction: column;
            align-items: center;
            .formItem{
                width: 100%;
                height: 36px;
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #E4E4E4;
                display: flex;
                align-items: center;
                padding: 0 12px;
                box-sizing: border-box;
                margin-bottom: 14px;
                .formIcon{
                    width: 16px;
                    height: 16px;
                }
                .inputBox{
                    flex: 1;
                    padding: 0 12px;
                    box-sizing: border-box;
                    color: #323233;
                    font-size: 14px;
                }
                .codeText{
                    font-size: 14px;
                    color: var(--theme-text-color);
                }
            }
        }
        .footerBox{
            width: 100%;
            height: 36px;
            background: var(--theme-color);
            font-size: 14px;
            color: var(--theme-btn);
            text-align: center;
            line-height: 36px;
            margin: 14px auto 0;
            border-radius: 50px;
            font-weight: bold;
        }
    }
    .checkUserCom{
        z-index: 99999;
        .userList{
            height: 400px;
            overflow-y: scroll;
            .userLi{
                display: flex;
                align-items: center;
                height: 40px;
                background: #F8F8F8;
                border-radius: 5px;
                margin-bottom: 12px;
                padding: 0 12px;
                box-sizing: border-box;
                font-size: 14px;
                color: #666;
                .icon{
                    width: 16px;
                    height: 16px;
                }
                .nameBox{
                    width: 80px;
                    margin-right: 24px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    .job_number{
                        margin-left: 8px;
                    }
                }
                .mobile{
                    flex: 1;
                }
            }
            .activeUser{
                font-weight: 600;
                color: var(--theme-text-color);
                background: #FFFBE5;
            }
        }
        .affirmUser{
            height: 40px;
            border-radius: 20px;
            background: var(--theme-color);
            font-size: 16px;
            color: var(--theme-btn);
            text-align: center;
            line-height: 40px;
            font-weight: 600;
            margin-top: 30px;
        }
    }
</style>